<template>
  <page-template>
    <template slot="page-content">
      <div class="generic-page--template page-template">
        <!-- page bg -->
        <div class="db fixed top-0 bottom-0 w-100 vh-100  z-1"></div>
        <div class="db fixed top-0 bottom-0 w-100 vh-100 z-2" ></div>

         <div class="relative container-fluid-ns mw9 center">
          <div class="row relative center pt5-ns z-5">
            <div class="col-sm-7 pr4-ns w-100">
              <img class="w-100" v-lazy="page.featured_image" />
            </div>
            <div class="col-sm-5 relative">
              <div class="container-fluid-sm">
                <h1 class="lh-heading is-blenny is-navy xxx-large mt4 mt0-m mt0-l is-tablet-cond-bold is-black abs-center-ns">{{ page.page_title }}</h1>
              </div>
            </div>
          </div>
        </div>
         <div class="relative container-fluid mw9 center">
          <div class="row middle-sm relative center mb4 z-5">
            <div class="col-xs-12 col-sm-10 center mt6-ns mb5">
              <div class="is-tablet-regular f5 lh-title cms-content" v-html="marked(page.content)"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>
<script>
import Marked from 'marked';
import PageTemplate from './page-template.vue';
export default {
  props: ['pageMarkdownFileName'],
  components: {
    PageTemplate
  },
  metaInfo () {
    return {
      title: this.post.title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.post.excerpt },
        { vmid: 'og:image', property: 'og:image', content: this.post.featured_image},
        { vmid: 'twitter:image', name: 'twitter:image', content: this.post.featured_image},
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      // parallax:null,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('311.markdown');
      return pageData[0];
    },
  },
  filters: {
    marked: function (val) {
      return Marked(val);
    }
  },
  methods : {
    scrollBg: function() {
      if (window.scrollY > this.bgScrollStart) {
        //
    }
  },
  created() {
  },
  destroyed() {
  },
},}
</script>